import { render, staticRenderFns } from "./VuePageTransition.vue?vue&type=template&id=5ba88be5&scoped=true&"
import script from "./VuePageTransition.vue?vue&type=script&lang=js&"
export * from "./VuePageTransition.vue?vue&type=script&lang=js&"
import style0 from "./VuePageTransition.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VuePageTransition.vue?vue&type=style&index=1&id=5ba88be5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba88be5",
  null
  
)

export default component.exports